import { NeutralColors } from 'portfolio3/styles';
import { SxStyles } from 'types';

export const root: SxStyles = {
  padding: '20px',

  border: '1px solid',
  borderRadius: '12px',
  borderColor: NeutralColors.night_neutrals_700,
};
